import { defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"
import BootstrapButton from "./BootstrapButton"
import Form from "./Form"
import FormButtons from "./FormButtons"

interface Props {
	confirmText: string
	cancelText: string
	onCancel(): void
	onSubmit(): void
}

const ConfirmForm: ReactiveComponent<Props> = (props, { slots }) => {
	return () => (
		<Form class="flex flex-col" onSubmit={props.onSubmit}>
			{renderSlot(slots)}
			<hr class="w-full" />
			<FormButtons>
				<BootstrapButton type="button" color="secondary" onClick={props.onCancel}>
					{props.cancelText}
				</BootstrapButton>
				<BootstrapButton type="submit" color="primary">
					{props.confirmText}
				</BootstrapButton>
			</FormButtons>
		</Form>
	)
}

export default defineComponent(ConfirmForm, inferProps<Props>())
